import { createContext } from 'react';
import type { IHttpClientProviderContext } from './types';

export const HttpClientProviderContext = createContext({} as IHttpClientProviderContext);
